module.exports = __webpack_public_path__ + "d48350e81b610792f75aefce55d543a8.png";